import React from 'react';
import Utils from '../../providers/Utils';
import SpecificComponent from '../SpecificComponent';
import avatar from '../../Pics/avatar.jpg'
import Ws from '../../providers/Ws';
import { FormControl, InputLabel, Select, Input, MenuItem } from '@material-ui/core';

export default class ConcediuLuni extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listDaysOfWeek:
                [
                    {
                        name: 'lu',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'ma',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'mi',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'jo',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'vi',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'sa',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'rgba(202, 202, 202, 0.63)',
                        pontajList: []
                    },
                    {
                        name: 'du',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'rgba(202, 202, 202, 0.63)',
                        pontajList: []
                    }

                ],


        }
    }

    componentDidMount() {

    }

    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }


    getProgramatorInfo = () => {
        let angajati = [...this.props.angajati]
        let pontaje = [...this.props.pontajeAll]

        let u = new Utils();

        let nrOfDaysInMonth = u.getDaysInMonth(this.props.anul, this.props.luna)

        let dataSelected = new Date().setFullYear(this.props.anul)
        dataSelected = new Date(dataSelected).setMonth(this.props.luna - 1)

        // console.warn('nrOfDaysInMonth :', nrOfDaysInMonth);

        let tableHead = []

        let tH = []

        let table = []

        let tBody = []


        // console.log('angajati :', angajati);

        // console.log('pontaje :', pontaje);


        for (let i = -1, n = angajati.length; i < n; i++) {
            let tr = []
            for (let j = 0; j < nrOfDaysInMonth; j++) {
                if (i === -1) {
                    let date = new Date(dataSelected).setDate(j)
                    tH.push(<th style={{ border: '1px solid #d8d4d4', backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].backgroundColor, color: '#72816e' }} key={`th${j}`}>{this.state.listDaysOfWeek[new Date(date).getDay()].name} </th>)

                } else {
                    let dataCalendar = u.transformDataForSql(new Date(dataSelected).setDate(j + 1));

                    let filterPontaje = pontaje.filter(p => p.id_angajat === angajati[i].id)

                    filterPontaje = filterPontaje.filter(p => p.id_concediu !== null)

                    let idx = filterPontaje.findIndex(p => u.ParseDataFromSql(p.la_data) === dataCalendar)



                    if (idx !== -1) {
                        tr.push(<td onClick={() => { this.props.openConcediuDialogUpdate(angajati[i], filterPontaje[idx]) }} key={`td${angajati[i].id}${j}`} style={{ backgroundColor: 'orange', color: 'white', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    } else {
                        tr.push(<td onClick={() => { this.props.openConcediuDialogInsert(angajati[i], new Date(dataCalendar)) }} key={`td${angajati[i].id}${j}`} style={{ backgroundColor: (new Date(dataCalendar).getDay() === 6 || new Date(dataCalendar).getDay() === 0) ? 'rgba(202, 202, 202, 0.63)' : 'white', color: (new Date(dataCalendar).getDay() === 6 || new Date(dataCalendar).getDay() === 0) ? 'white' : 'rgba(202, 202, 202, 0.63)', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    }
                }
            }

            if (i !== -1) {
                tr = (<tr key={`tr${angajati[i].id}`}>
                    <td style={{ padding: '5px 0 5px 0 ' }} colSpan={4} >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                                // onClick={()=>{this.selectFile(`file${s.id}`)}}
                                onClick={() => { this.props.openDetaliiAngajat(angajati[i]) }}
                                className='pm-angajati-picture'
                                style={{ backgroundImage: `url('${angajati[i].poza ? (new Ws().adresaMedia + '/Angajati/' + angajati[i].poza) : avatar}')` }}>

                            </div>



                            <span
                                style={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    width: 130,
                                    display: 'inline-block',
                                    whiteSpace: 'nowrap'

                                }}
                                className='pm-title'>
                                {angajati[i].nume}
                            </span>

                        </div>
                    </td>
                    {tr}
                </tr>)

                tBody.push(tr)

            }





        }



        tableHead = (<thead>
            <tr>
                <th style={{ borderBottom: '1px solid #d8d4d4' }} colSpan={4}>
                    <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                        <InputLabel htmlFor="resursa">Departament</InputLabel>
                        <Select

                            value={this.props.departament || ""}
                            onChange={this.props.changeDepartament}

                            input={<Input id="resursa" />}>

                            <MenuItem value={-1} >Toate</MenuItem>

                            {this.props.departamente.map((s, idx) => {
                                return <MenuItem value={s.id} key={idx}  > {s.nume}</MenuItem>

                            })
                            }
                        </Select>
                    </FormControl>

                </th>
                {tH}
            </tr>
        </thead>)



        table = (<table style={{ width: '95%',minWidth:1420, margin: '20px auto', tableLayout: 'fixed', borderCollapse: 'collapse', backgroundColor: 'white' }}>
            {tableHead}<tbody>{tBody}</tbody></table>)

        return table

    }
    render() {
        return (
            <div>
                <h2 className='pm-title' >Concedii</h2>
                <div className='monthcalendar-header'>
                    <i onClick={this.props.minusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_back</i>
                    <span style={{ fontSize: 20 }} className='monthcalendar-title'>{this.numeLuna(this.props.luna)} - {this.props.anul}</span>
                    <i onClick={this.props.plusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_forward</i>
                </div>

                <div style={{ textAlign: 'center' }}>
                    <div style={{ backgroundColor: 'orange', verticalAlign: 'sub' }} className='pm-task-legend'></div>
                    <span className='pm-title'>Concediu de odihna</span>

                </div>

                <div style={{ width: '98%', overflow: 'auto' }}>

                    {this.getProgramatorInfo()}
                </div>
            </div>
        );
    }
}